heat_treatments-index
  forms-heat_treatments-search(tag-scope="forms_heat_treatments_search")
  heat_treatments-table(tag-scope="heat_treatments_table")
  script(type="typescript").
    this.mixin('base');
